/* 1500 Hours · airport-first homepage (sections/h15-home.liquid). v1 2026-10-11 (dark plate, home-v2); v3 look 2026-10-13
   (white, home-v3/template.html): no plate, no engraved marks, + the o-ring under the card and a checkride tile that follows the field.

   One field drives every tile. Art comes from the h15-card-render Worker, the same two calls the PDPs make:
     card face  /?code=CODE          -> the back of the hoodie/crewneck and the card tile
     hat ink    /?m=hat&code=CODE    -> both hats and the crewneck chest; x-h15-name = the field's name
     checkride  /?m=cr&code=CODE&... -> the checkride tile in "more cards", only for a field someone typed (not the demo)
   The Worker allows 10 renders / 10 s per IP; popular fields are edge-cached and its answers are immutable for
   30 days, so each field is asked for once per visit (promise cache) and typing is debounced.
   Until someone types, the field cycles the section's demo airports and the products follow. It stops on
   focus, typing or scroll. A confirmed field is remembered (localStorage h15.airport) and every tile links
   to its PDP with ?airport=CODE (the PDPs prefill from it). If the Worker fails, the demo fields fall back
   to the baked art in the section config (snippets/h15-home-art.liquid) and a typed field still carries to
   the PDP. Reviews: the Judge.me widget endpoint (public token), pinned entries first.
*/
(function () {
  'use strict';

  var NATO = { A: 'alfa', B: 'bravo', C: 'charlie', D: 'delta', E: 'echo', F: 'foxtrot', G: 'golf', H: 'hotel', I: 'india', J: 'juliett', K: 'kilo', L: 'lima', M: 'mike',
    N: 'november', O: 'oscar', P: 'papa', Q: 'quebec', R: 'romeo', S: 'sierra', T: 'tango', U: 'uniform', V: 'victor', W: 'whiskey', X: 'x-ray', Y: 'yankee', Z: 'zulu',
    0: 'zero', 1: 'one', 2: 'two', 3: 'three', 4: 'four', 5: 'five', 6: 'six', 7: 'seven', 8: 'eight', 9: 'niner' };

  // placements copied from the live PDP scripts (hat-pdp.js, rope-hat-pdp.js, apparel-pdp.js); the cutouts share
  // the blank photos' frame, so the same percentages land the art in the same spot
  var HATBOX = 'left:25.81%;top:27.36%;width:48.46%;height:20.1%';
  var ROPEBOX = 'left:29.58%;top:37.10%;width:40.85%;height:17.83%';
  var THREAD = { black: ['#f3f2ee', 'h15homeThreadLight'], ivory: ['#141414', 'h15homeThreadDark'] };
  var GARM = {
    hoodie:   { back:  { pct: [33.875, 19.312, 32.25, 42.938], pf: [1800, 2400], mask: 'hoodie' } },
    crewneck: { front: { pct: [30.875, 11.625, 38.188, 50.812], pf: [1800, 2400], chest: [1296, 210] } }
  };
  var KEEP = { polygon: ['points'], path: ['d', 'transform'],
               text: ['x', 'y', 'text-anchor', 'font-weight', 'font-size', 'letter-spacing'] };

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function clean(s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 4); }
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { if (v) localStorage.setItem(k, v); else localStorage.removeItem(k); } catch (e) {} }

  // the Worker's SVG is ours, but it still goes in with innerHTML: rebuild polygons, paths and text from a fixed
  // attribute list (same rule as apparel-pdp.js). The card's background rect + hole circles are dropped.
  function safeArt(svg) {
    try {
      var doc = new DOMParser().parseFromString(svg, 'image/svg+xml');
      if (doc.querySelector('parsererror')) return '';
      var out = '';
      doc.querySelectorAll('polygon, path, text').forEach(function (n) {
        var tag = n.tagName.toLowerCase(), a = '';
        KEEP[tag].forEach(function (k) { var v = n.getAttribute(k); if (v != null) a += ' ' + k + '="' + esc(v) + '"'; });
        out += tag === 'text' ? '<text' + a + '>' + esc(n.textContent) + '</text>' : '<' + tag + a + '/>';
      });
      return out;
    } catch (e) { return ''; }
  }

  function init(root) {
    if (!root || root.__h15home) return;
    root.__h15home = true;
    var CFG = {};
    try { CFG = JSON.parse(root.querySelector('.h15home-cfg').textContent); } catch (e) { return; }
    var FB = (CFG.fb && CFG.fb.art) || {};
    var DEMO = (CFG.demo || []).filter(function (c) { return /^[A-Z0-9]{3,4}$/.test(c); });
    if (!DEMO.length) DEMO = ['KJFK'];

    var $ = function (s) { return root.querySelector(s); };
    var input = $('input.hm-ident'), statusEl = $('.hm-status'), codeWrap = $('.hm-code'), phonEl = $('.hm-phon');
    var tiles = [].slice.call(root.querySelectorAll('.hm-tile'));
    var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------- art from the Worker (one promise per field per visit), baked art as the fallback ---------- */
    var cache = {};
    function get(path) { return fetch(CFG.endpoint + path, { credentials: 'omit' }); }
    function getArt(code) {
      if (cache[code]) return cache[code];
      var p = Promise.all([get('/?code=' + encodeURIComponent(code)), get('/?m=hat&code=' + encodeURIComponent(code))])
        .then(function (rs) {
          var card = rs[0], hat = rs[1];
          if (card.status === 404 || hat.status === 404) throw { miss: true };
          if (!card.ok || !hat.ok) throw { down: true };
          var disp = clean(card.headers.get('x-h15-disp') || hat.headers.get('x-h15-disp') || code), name = '';
          try { name = decodeURIComponent(hat.headers.get('x-h15-name') || ''); } catch (e) {}
          return Promise.all([card.text(), hat.text()]).then(function (t) {
            var r = { c: safeArt(t[0]), h: safeArt(t[1]), disp: disp, name: name.toLowerCase() };
            if (!r.c || !r.h) throw { down: true };
            return r;
          });
        });
      cache[code] = p;
      p.catch(function (e) { if (!e || !e.miss) delete cache[code]; });   // a 404 is an answer; an outage is not
      return p;
    }
    function baked(code) {
      var b = FB[code] || (code.length === 3 && FB['K' + code]);
      return b ? { c: b.c, h: b.h, disp: FB[code] ? code : 'K' + code, name: b.n || '', baked: true } : null;
    }
    // the demo never waits long: the Worker's answer if it comes quickly, else the baked frame
    function artOrBaked(code) {
      return getArt(code).catch(function (e) { var b = baked(code); if (b) return b; throw e; });
    }

    /* ---------- drawing ---------- */
    // the o-ring that ships with every card: a real photo (assets/h15-home-ring.webp, measured at 1.05 in across =
    // 105 card units), tucked under the card's left edge with the card's shadow on it. The viewBox widens to hold it
    // (RX0 = ring edge + its shadow), so the card + ring center as one object. Ported from the store v3 prototype 10-13.
    var RING = { side: 105 / 0.94, c: [2, 270] }, RX0 = -54;
    function ringUnder() {
      if (!CFG.ring) return '';
      var s = RING.side, x = RING.c[0] - s / 2, y = RING.c[1] - s / 2;
      return '<image href="' + esc(CFG.ring) + '" x="' + x.toFixed(2) + '" y="' + y.toFixed(2) + '" width="' + s.toFixed(2) + '" height="' + s.toFixed(2) + '" filter="url(#h15home-ring-sh)"/>' +
        '<g clip-path="url(#h15home-rc)"><rect width="212.5" height="337" rx="12.5" fill="#000" opacity=".6" filter="url(#h15home-ring-cast)"/></g>';
    }
    function cardArt(a) {
      var r = ringUnder();
      return '<svg class="hm-card-svg hm-art-swap" viewBox="' + (r ? RX0 + ' 0 ' + (212.5 - RX0) : '0 0 212.5') + ' 337" aria-hidden="true">' + r + '<g mask="url(#h15home-hole)">' +
        '<rect width="212.5" height="337" rx="12.5" fill="var(--metal)"/>' +
        '<rect width="212.5" height="337" rx="12.5" fill="url(#h15home-light)"/>' +
        '<g fill="var(--etch)" font-family="Montserrat, sans-serif">' + a.c + '</g>' +
        '<rect width="212.5" height="337" rx="12.5" fill="#fff" filter="url(#h15home-grain)" opacity=".05"/>' +
        '<rect x=".6" y=".6" width="211.3" height="335.8" rx="11.9" fill="none" stroke="url(#h15home-edge)" stroke-width="1.2"/>' +
        '</g></svg>';
    }
    function hatArt(a, color, box) {
      var t = THREAD[color];
      return '<svg class="hm-art hm-art-swap" style="' + box + '" viewBox="0 0 400 175" preserveAspectRatio="none" aria-hidden="true">' +
        '<g fill="' + t[0] + '" filter="url(#' + t[1] + ')">' + a.h + '</g></svg>';
    }
    function boxStyle(b) {
      var p = b.pct, m = b.mask && CFG.masks ? CFG.masks[b.mask] : '';
      return 'left:' + p[0] + '%;top:' + p[1] + '%;width:' + p[2] + '%;height:' + p[3] + '%' +
        (m ? ';-webkit-mask-image:url(' + m + ');mask-image:url(' + m + ')' : '');
    }
    function backArt(a) {          // the whole card on the back: card frame (18,40)-(194.5,300) at 1466 x 2160, 1.2 in down
      var b = GARM.hoodie.back, pf = b.pf;
      return '<svg class="hm-art hm-art-swap" style="' + boxStyle(b) + '" viewBox="0 0 ' + pf[0] + ' ' + pf[1] + '" aria-hidden="true">' +
        '<svg x="' + Math.round((pf[0] - 1466) / 2) + '" y="180" width="1466" height="2160" viewBox="18 40 176.5 260" preserveAspectRatio="none">' +
        '<g fill="var(--bone)" font-family="Montserrat, sans-serif">' + a.c + '</g></svg></svg>';
    }
    function chestArt(a) {         // the runways on the chest, 3.0 in wide by their ink bounds (fitChest)
      var b = GARM.crewneck.front, pf = b.pf;
      return '<svg class="hm-art hm-art-swap" style="' + boxStyle(b) + '" viewBox="0 0 ' + pf[0] + ' ' + pf[1] + '" aria-hidden="true">' +
        '<svg class="hm-chest" data-cx="' + b.chest[0] + '" data-top="' + b.chest[1] + '" x="0" y="0" width="0" height="0" viewBox="0 0 400 175" preserveAspectRatio="none">' +
        '<g fill="var(--bone)">' + a.h + '</g></svg></svg>';
    }
    function fitChest(host) {
      host.querySelectorAll('svg.hm-chest').forEach(function (inner) {
        var g = inner.querySelector('g'), bb;
        try { bb = g.getBBox(); } catch (e) { return; }
        if (!bb || !bb.width) return;
        var w = 450, h = w * bb.height / bb.width;
        inner.setAttribute('viewBox', bb.x + ' ' + bb.y + ' ' + bb.width + ' ' + bb.height);
        inner.setAttribute('x', +inner.dataset.cx - w / 2); inner.setAttribute('y', inner.dataset.top);
        inner.setAttribute('width', w); inner.setAttribute('height', h);
      });
    }
    function artFor(pid, a) {
      if (pid === 'card') return '<div class="hm-cardwrap">' + cardArt(a) + '</div>';
      if (pid === 'hat') return hatArt(a, 'black', HATBOX);
      if (pid === 'rope') return hatArt(a, 'ivory', ROPEBOX);
      if (pid === 'hoodie') return backArt(a);
      return chestArt(a);
    }
    // the ripple: tiles swap their art one after another, card first
    var shown = '';
    function paint(a, fade) {
      if (!a) return;
      shown = a.disp;
      tiles.forEach(function (t, i) {
        var slot = t.querySelector('.hm-artslot'), html = artFor(t.dataset.p, a);
        if (!fade || REDUCE) { slot.innerHTML = html; fitChest(slot); return; }
        setTimeout(function () {
          slot.querySelectorAll('.hm-art-swap').forEach(function (n) { n.classList.add('hm-swap'); });
          setTimeout(function () {
            slot.innerHTML = html;
            var fresh = slot.querySelectorAll('.hm-art-swap');
            fresh.forEach(function (n) { n.classList.add('hm-swap'); });
            fitChest(slot);
            requestAnimationFrame(function () { requestAnimationFrame(function () { fresh.forEach(function (n) { n.classList.remove('hm-swap'); }); }); });
          }, 140);
        }, i * 70);
      });
      paintPhon(a.disp, fade);
    }
    function paintPhon(code, fade) {
      var txt = code.split('').map(function (ch) { return NATO[ch] || ch; }).join('  ·  ');
      if (!phonEl || phonEl.textContent === txt) return;
      if (!fade || REDUCE) { phonEl.textContent = txt; return; }
      phonEl.classList.add('hm-swap');
      setTimeout(function () { phonEl.textContent = txt; phonEl.classList.remove('hm-swap'); }, 190);
    }

    /* ---------- links: every tile carries the confirmed (or typed-but-unknown) field to its PDP ---------- */
    function setLinks(code) {
      tiles.forEach(function (t) {
        var base = t.dataset.href;
        t.href = code ? base + (base.indexOf('?') < 0 ? '?' : '&') + 'airport=' + encodeURIComponent(code) : base;
      });
    }

    /* ---------- the field ---------- */
    var st = { code: '', typed: '', unknown: '' };   // code = confirmed + canonical (BJC -> KBJC), typed = what was typed for it
    var demo = { i: 0, code: DEMO[0], timer: 0 };
    var seq = 0, debounce = 0;
    function setStatus(kind, html) { statusEl.className = 'hm-status' + (kind ? ' hm-' + kind : ''); statusEl.innerHTML = html; }
    function idleStatus() { setStatus('', 'type your airport · showing <b>' + esc(demo.code) + '</b>'); }
    function line(kind) {
      codeWrap.classList.toggle('hm-is-ok', kind === 'ok');
      codeWrap.classList.toggle('hm-is-miss', kind === 'miss');
    }
    function mailto(code) {   // same subject as the card builder's "email us for <CODE>", so fastmail/sweep.py tags it "+"
      return 'mailto:' + CFG.email + '?subject=' + encodeURIComponent(code + ' request') +
        '&body=' + encodeURIComponent('hi,\n\nyou don\'t have ' + code + ' yet. could you draw it and send me a proof? i\'ll order once it looks right.\n\nairport: ' + code + '\n\nanything else, like the frequencies you want on it:\n\n');
    }
    function accept(r, v) {
      st.code = r.disp; st.typed = v || r.disp; st.unknown = '';
      setStatus('ok', esc(r.disp) + (r.name ? ' · ' + esc(r.name) : ''));
      line('ok'); setLinks(r.disp); lsSet('h15.airport', r.disp);
      if (shown !== r.disp) paint(r, true);
      if (!r.baked) crArt(r.disp);
    }
    var retry = 0;
    function lookup(v) {
      var my = ++seq;
      clearTimeout(retry);
      getArt(v).then(function (r) {
        if (my !== seq || clean(input.value) !== v) return;
        accept(r, v);
      }, function (e) {
        if (my !== seq || clean(input.value) !== v) return;
        if (e && e.miss) {
          st.code = '';
          if (v.length < 4) { setStatus('', 'keep typing…'); line(''); setLinks(''); return; }
          st.unknown = v; line('miss'); setLinks(v);
          setStatus('bad', 'we don’t have ' + esc(v) + ' yet. <a href="' + mailto(v) + '">email us</a> and we’ll draw it.');
          return;
        }
        var b = baked(v);                                    // Worker down or rate-limited: baked art if we have it
        if (b) { accept(b, v); return; }
        st.code = ''; line(''); setLinks(v);
        setStatus('', 'can’t draw a preview right now. tap a product and ' + esc(v) + ' comes with you.');
        retry = setTimeout(function () { if (clean(input.value) === v && !st.code) lookup(v); }, 8000);   // a 429 clears in 10 s
      });
    }
    input.addEventListener('input', function () {
      var v = clean(input.value);
      if (input.value !== v) input.value = v;
      clearTimeout(debounce); seq++;
      stopDemo();
      if (!v) {
        st.code = ''; st.unknown = ''; line(''); setLinks(''); lsSet('h15.airport', ''); idleStatus();
        if (shown !== demo.code) artOrBaked(demo.code).then(function (a) { if (!input.value) paint(a, true); }, function () {});
        return;
      }
      if (v.length < 3) { st.code = ''; line(''); setLinks(''); setStatus('', 'keep typing…'); return; }
      debounce = setTimeout(function () { lookup(v); }, 260);
    });
    function normalize() {                                   // BJC -> KBJC once the Worker said so
      if (st.code && st.typed === clean(input.value) && input.value !== st.code) input.value = st.code;
    }

    /* ---------- a blinking caret just before the first letter: this is where you type (Nathan 10-13) ---------- */
    var caretEl = $('.hm-caret'), measure = $('.hm-measure');
    function placeCaret() {
      if (!caretEl || !measure) return;
      codeWrap.classList.toggle('hm-has-v', !!input.value);
      measure.textContent = input.placeholder || '';
      var cs = getComputedStyle(input), pl = parseFloat(cs.paddingLeft) || 0, pr = parseFloat(cs.paddingRight) || 0;
      caretEl.style.left = (pl + (input.clientWidth - pl - pr - measure.getBoundingClientRect().width) / 2) + 'px';
    }
    if (window.MutationObserver) new MutationObserver(placeCaret).observe(input, { attributes: true, attributeFilter: ['placeholder'] });
    input.addEventListener('input', placeCaret);
    window.addEventListener('resize', placeCaret);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeCaret);
    placeCaret();
    input.addEventListener('focus', function () { stopDemo(); input.placeholder = ''; });
    input.addEventListener('blur', function () {
      normalize();
      if (!input.value) { input.placeholder = demo.code; schedule(2400); }
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); normalize(); input.blur(); } });
    // a tap on a tile while the field holds an unconfirmed code still carries it (setLinks ran on input)

    /* ---------- the cycling field: erase, type the next field, the products follow, hold ---------- */
    function demoOn() {
      return !REDUCE && !st.code && !input.value && document.activeElement !== input && window.scrollY < 260 && !document.hidden;
    }
    function stopDemo() { clearTimeout(demo.timer); demo.timer = 0; }
    function schedule(ms) { clearTimeout(demo.timer); demo.timer = setTimeout(demoTick, ms); }
    function demoTick() {
      if (!demoOn()) return schedule(1500);
      var next = DEMO[(demo.i = (demo.i + 1) % DEMO.length)], k = demo.code.length, j = 0;
      var ready = artOrBaked(next);                          // fetch while the old code erases
      function bail() { if (!input.value && document.activeElement !== input) input.placeholder = demo.code; schedule(1500); }
      (function erase() {
        if (!demoOn()) return bail();
        if (k > 0) { input.placeholder = demo.code.slice(0, --k); return setTimeout(erase, 60); }
        (function type() {
          if (!demoOn()) return bail();
          input.placeholder = next.slice(0, ++j);
          if (j < next.length) return setTimeout(type, 105);
          ready.then(function (a) {
            if (!demoOn()) return bail();
            demo.code = next; idleStatus(); paint(a, true); schedule(3600);
          }, function () { input.placeholder = demo.code; schedule(1500); });   // no art for it: keep the last one up
        })();
      })();
    }

    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { tiles.forEach(function (t) { fitChest(t); }); });

    /* ---------- more cards: the checkride tile redraws for a field someone typed (one Worker call per field) ---------- */
    var crSlot = $('.hm-mstage[data-m="checkride"]'), crShown = '', crSeq = 0;
    function crArt(code) {
      if (!crSlot || !CFG.cr || crShown === code) return;
      var my = ++crSeq, c = CFG.cr;
      get('/?m=cr&code=' + encodeURIComponent(code) + '&rating=' + encodeURIComponent(c.rating) + '&name=' + encodeURIComponent(c.name) + '&date=' + encodeURIComponent(c.date))
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) {
          var art = t && safeArt(t);
          if (!art || my !== crSeq) return;                  // keep the example card up if the Worker says no
          crShown = code;
          var old = crSlot.querySelector('svg');
          if (old && !REDUCE) old.classList.add('hm-swap');
          setTimeout(function () {
            crSlot.innerHTML = cardArt({ c: art });
            var n = crSlot.querySelector('svg'); n.classList.add('hm-swap');
            requestAnimationFrame(function () { requestAnimationFrame(function () { n.classList.remove('hm-swap'); }); });
          }, REDUCE ? 0 : 160);
        }, function () {});
    }

    /* ---------- states the server can't know: the drop gate (time) and a restock preview tab ---------- */
    function states() {
      var opens = Date.parse(CFG.opensAt || '');
      root.querySelectorAll('.hm-note[data-note="gate"]').forEach(function (n) { n.hidden = !(opens && Date.now() < opens); });
      if (document.documentElement.classList.contains('h15r-on')) {
        var card = root.querySelector('.hm-tile[data-p="card"]');
        if (card && !card.querySelector('.hm-note')) card.insertAdjacentHTML('beforeend', '<div class="hm-note" data-note="restock">sold out · get on the list</div>');
      }
    }

    /* ---------- the logbook: Judge.me, pinned entries first ---------- */
    function logbook() {
      var J = CFG.jm || {};
      if (!J.token || !J.shop || !window.DOMParser) return;
      var rowsEl = $('.hm-lb-rows'), sum = $('.hm-log-sum'), more = $('[data-more]'), want = +J.rows || 5;
      var year = ($('.hm-lb-head .hm-dt small') || {}).textContent || '';
      function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
      function kind(t) {
        t = norm(t);
        if (!t) return 'the shop';
        if (t.indexOf('checkride') > -1) return 'checkride card';
        if (t.indexOf('airline') > -1) return 'airline card';
        if (t.indexOf('rope') > -1) return 'rope hat';
        if (t.indexOf('hat') > -1) return 'hat';
        if (t.indexOf('hoodie') > -1) return 'hoodie';
        if (t.indexOf('crewneck') > -1) return 'crewneck';
        if (t.indexOf('personalization') > -1 || t.indexOf('add on') > -1) return 'custom card';
        if (t === 'the card') return 'the card';
        return 'airport card';
      }
      function who(a, verified) {
        var p = norm(a).split(' ').filter(Boolean);
        if (!p.length || p[0] === 'anonymous') return verified ? 'verified buyer' : 'anonymous';
        return p[0] + (p[1] ? ' ' + p[1].charAt(0) + '.' : '');
      }
      function row(r) {
        var d = r.date.split('-');                            // 2026-08-29 -> 08 · 29 (the year lives in the header)
        var dt = d.length === 3 ? d[1] + ' · ' + d[2] + (year && d[0] !== year ? ' · ' + d[0].slice(2) : '') : '';
        return '<div class="hm-lb-row" role="row"><div class="hm-c hm-dt hm-pen" role="cell">' + esc(dt) + '</div>' +
          '<div class="hm-c hm-it hm-pen" role="cell">' + esc(r.kind) + '</div><div class="hm-c hm-nm hm-pen" role="cell">' + esc(r.who) + '</div>' +
          '<div class="hm-c hm-rm" role="cell">' + esc(r.body) + '</div>' +
          '<div class="hm-c hm-rt" role="cell" aria-label="' + r.score + ' of 5"><b>' + r.score + '</b><i class="hm-star">★</i></div></div>';
      }
      var url = 'https://judge.me/api/v1/widgets/all_reviews_page?api_token=' + encodeURIComponent(J.token) +
        '&shop_domain=' + encodeURIComponent(J.shop) + '&per_page=50';
      fetch(url, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
        if (!d || !d.all_reviews) return;
        var doc = new DOMParser().parseFromString('<div>' + d.all_reviews + '</div>', 'text/html');
        var live = [].slice.call(doc.querySelectorAll('.jdgm-rev')).map(function (n) {
          var q = function (s) { return n.querySelector(s); };
          var body = ((q('.jdgm-rev__body') || {}).textContent || '').replace(/\s+/g, ' ').trim();
          var ts = (q('.jdgm-rev__timestamp') || { getAttribute: function () { return ''; } }).getAttribute('data-content') || '';
          return {
            score: +((q('.jdgm-rev__rating') || { getAttribute: function () { return 0; } }).getAttribute('data-score')) || 0,
            date: ts.slice(0, 10), body: body, key: norm(body).slice(0, 48),
            kind: kind((q('.jdgm-rev__prod-link') || {}).textContent),
            who: who((q('.jdgm-rev__author') || {}).textContent, n.getAttribute('data-verified-buyer') === 'true')
          };
        }).filter(function (r) { return r.body && r.score >= 4; });
        if (!live.length) return;
        var head = new DOMParser().parseFromString('<div>' + (d.all_reviews_header || '') + '</div>', 'text/html').querySelector('[data-number-of-reviews]');
        if (head && sum) {
          var n = +head.getAttribute('data-number-of-reviews') || 0, avg = parseFloat(head.getAttribute('data-average-rating')) || 0;
          if (n > 0) { sum.textContent = '★ ' + avg.toFixed(1) + ' · ' + n + ' review' + (n === 1 ? '' : 's'); sum.hidden = false; }
        }
        // pinned entries stay only while Judge.me still has them (a deleted review must not live on here)
        var used = {};
        [].slice.call(rowsEl.querySelectorAll('[data-pin]')).forEach(function (pin) {
          var k = norm(pin.querySelector('.hm-rm').textContent).slice(0, 48), hit = null;
          live.forEach(function (r, i) { if (!hit && !used[i] && r.key && (r.key.indexOf(k.slice(0, 32)) === 0 || k.indexOf(r.key.slice(0, 32)) === 0)) { hit = r; used[i] = 1; } });
          if (!hit) pin.remove();
        });
        var rest = live.filter(function (r, i) { return !used[i]; });   // newest first, as Judge.me sends them
        var have = rowsEl.querySelectorAll('.hm-lb-row').length;
        if (have < want) rowsEl.insertAdjacentHTML('beforeend', rest.splice(0, want - have).map(row).join(''));
        if (more) {
          if (!rest.length) { more.parentNode.hidden = true; return; }
          more.setAttribute('href', '#');
          more.addEventListener('click', function (e) {    // turn the page: the rest of the logbook, right here
            e.preventDefault();
            rowsEl.insertAdjacentHTML('beforeend', rest.map(row).join(''));
            more.parentNode.hidden = true;
          });
        }
      }).catch(function () {});
    }

    /* ---------- start ---------- */
    var saved = clean(lsGet('h15.airport'));
    var first = baked(DEMO[0]);
    if (first) { paint(first, false); }
    if (saved && saved.length >= 3) {
      input.value = saved; setStatus('', 'checking ' + esc(saved) + '…'); line('');
      lookup(saved);
    } else {
      idleStatus();
      // the baked first frame is up at once; swap in the Worker's own art for it quietly (no ripple) if nothing moved
      getArt(DEMO[0]).then(function (a) { if (!st.code && !input.value && demo.code === DEMO[0]) paint(a, false); }, function () {});
      schedule(2600);
    }
    window.addEventListener('scroll', function () { if (demo.timer === 0 && demoOn()) schedule(1500); }, { passive: true });
    document.addEventListener('visibilitychange', function () { if (!document.hidden && demoOn()) schedule(1500); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', states); else states();
    logbook();
  }

  function boot() { document.querySelectorAll('.h15home').forEach(init); }
  boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('.h15home'); if (r) init(r); });
})();
